import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
import StateListenerRegistry from '../base/redux/StateListenerRegistry';
import { disableChangeNameModeration, enableChangeNameModeration, localParticipantApproved, localParticipantRejected, participantApproved, participantRejected } from './slice';
/**
 * Registers a change handler for `state['features/base/conference'].conference` to
 * set the event listeners needed for the name-change moderation feature to operate.
 */
StateListenerRegistry.register(state => state['features/base/conference'].conference, (conference, { dispatch }, previousConference) => {
    if (conference && !previousConference) {
        conference.on(JitsiConferenceEvents.CHANGE_NAME_MODERATION_APPROVED, () => {
            dispatch(localParticipantApproved());
        });
        conference.on(JitsiConferenceEvents.CHANGE_NAME_MODERATION_REJECTED, () => {
            dispatch(localParticipantRejected());
        });
        conference.on(JitsiConferenceEvents.CHANGE_NAME_MODERATION_CHANGED, ({ enabled, actor }) => {
            enabled
                ? dispatch(enableChangeNameModeration(actor))
                : dispatch(disableChangeNameModeration(actor));
        });
        conference.on(JitsiConferenceEvents.CHANGE_NAME_MODERATION_PARTICIPANT_APPROVED, ({ participant }) => {
            const { _id: jid } = participant;
            dispatch(participantApproved({ jid }));
        });
        conference.on(JitsiConferenceEvents.CHANGE_NAME_MODERATION_PARTICIPANT_REJECTED, ({ participant }) => {
            const { _id: jid } = participant;
            dispatch(participantRejected({ jid }));
        });
    }
});
// Commented-out middleware logic, which can be improved and uncommented if necessary
// import { MiddlewareRegistry } from '../base/redux';
// import { PARTICIPANT_UPDATED, PARTICIPANT_JOINED } from '../base/participants/actions';
// import { getParticipantById, getLocalParticipant } from '../base/participants';
// import { getCurrentConference } from '../base/conference';
// let timeout: ReturnType<typeof setTimeout> | null = null;
// MiddlewareRegistry.register(({ dispatch, getState }) => next => action => {
//     const state = getState();
//     const conference = getCurrentConference(state);
//     switch (action.type) {
//         case PARTICIPANT_UPDATED: {
//             const { participant } = action;
//             const { name, id } = participant;
//             const oldParticipant = getParticipantById(state, id);
//             if (oldParticipant?.local && name && name !== oldParticipant?.name) {
//                 if (timeout) clearTimeout(timeout);
//                 timeout = setTimeout(() => {
//                     if (name !== getParticipantById(APP.store.getState(), id)?.name) {
//                         APP?.conference?.changeLocalDisplayName(name);
//                     }
//                 }, 300);
//             }
//             break;
//         }
//         case PARTICIPANT_JOINED: {
//             const { participant } = action;
//             const { name, id } = participant;
//             const oldParticipant = getParticipantById(state, id);
//             const localParticipant = getLocalParticipant(state);
//             const _p = conference?.getParticipantById(id);
//             const localUserId = JSON.parse(localStorage.getItem("user")!).id;
//             if (conference?._conferenceJoinAnalyticsEventSent && name && name !== localParticipant?.name && !oldParticipant?.local && localUserId == _p?._identity.user.id) {
//                 APP?.conference?.changeLocalDisplayName(name);
//             }
//             break;
//         }
//     }
//     return next(action);
// });
